
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from "react-toastify";


const StudentTable = (props) => {
    const { lstStudent, studentId, setStudentId, setStudent } = props;

    const [lstStudentFiltered, setLstStudentFiltered] = useState([]);
    const [selStudentId, setSelStudentId] = useState(0);

    useEffect(() => {
        // console.log("StudentTable called");
        setLstStudentFiltered(lstStudent);
    }, [lstStudent]);

    useEffect(() => {
        // console.log("StudentTable called");
        setSelStudentId(studentId);
    }, [studentId]);

    const handleSelectStudent = async (pStudent) => {
        // console.log("handleSelectStudnet called, pStudent", pStudent);
        if (selStudentId === pStudent.studentId) {
            await setStudentId(0);
            await setStudent("")
            setSelStudentId(0);
        } else {
            await setStudentId(pStudent.studentId);
            await setStudent(pStudent.name)
            setSelStudentId(pStudent.studentId);
        }
    }


    const colgrp = <colgroup>
        <col width="40"></col>
        <col width="100"></col>
        <col width="60"></col>
    </colgroup>



    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th >
                                Student Id
                            </th>
                            <th >
                                Student
                            </th>
                            <th >
                                Enrollment No
                            </th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "80vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="tcBodyTable" >
                            {lstStudentFiltered &&
                                lstStudentFiltered.map((student, i) => (
                                    <tr key={student.studentId}
                                        onClick={() => handleSelectStudent(student)}
                                        className={student.studentId === studentId ? "selected" : ''}>
                                        <td className="text-center">{student.studentId}</td>
                                        <td className="text-left">{student.name}</td>
                                        <td className="text-center">{student.regsNo}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default StudentTable;